module.exports = __webpack_public_path__ + "static/assets/58b1d982ce69a8bac44df0c5235be675.png";